import { Injectable } from '@angular/core';
import { Rest, RestService } from '@ralba/shared';
import {
  CreateOnboardingRequestNoteInputDto,
  OnboardingRequestNoteDto,
  TenancyRequestDto,
} from '../dto';

@Injectable({ providedIn: 'root' })
export class ManageOnboardingNotesHttpApiService {
  constructor(private rest: RestService) {}

  public getNotes(params: {
    Body: string;
    TenantId?: number | null;
    UserId?: number | null;
  }) {
    // GET binds TenancyRequestDto<Guid> from the query string, so the keys are
    // PascalCase (Body/TenantId/UserId) — same shape as
    // ManageOnboardingHttpApiService.getOnboarding.
    const request: Rest.Request<null> = {
      method: 'GET',
      url: '/api/manage/onboarding-notes/get',
      params,
    };
    return this.rest.request<
      null,
      Rest.AbpResponse<OnboardingRequestNoteDto[]>
    >(request);
  }

  public createNote(
    body: TenancyRequestDto<CreateOnboardingRequestNoteInputDto>
  ) {
    const request: Rest.Request<
      TenancyRequestDto<CreateOnboardingRequestNoteInputDto>
    > = {
      method: 'POST',
      url: '/api/manage/onboarding-notes/create',
      body,
    };
    return this.rest.request<
      TenancyRequestDto<CreateOnboardingRequestNoteInputDto>,
      Rest.AbpResponse<OnboardingRequestNoteDto>
    >(request);
  }
}
